// extracted by mini-css-extract-plugin
export default {"loading":"SuspenseLoader_loading__6o5yb"};